import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import { parsePlannerEventTags } from '@/shared/converters/tagConverters';
import { parseVehicleSummary } from '@/vehicle/converters/vehicleConverters';
import PlannerEvent from '../models/PlannerEvent';

const SCHEMA = {
  id: 'id',
  resourceId: 'resourceId',
  start: (data: any) => parseMoment(data.startsAt, DateTimeFormat.LEGACY),
  end: (data: any) => parseMoment(data.stopsAt, DateTimeFormat.LEGACY),
  duration: 'duration',
  eventType: 'eventType',
  editable: 'editable',
  dossierId: 'extendedProps.dossierId',
  hasRepairOrder: 'extendedProps.hasRepairOrder',
  externalReference: 'extendedProps.repairOrderRef',
  isStopped: 'extendedProps.isStopped',
  vehicleStatus: 'extendedProps.objectStatus',
  workStatus: 'extendedProps.workStatus',
  waitsOnPremise: 'extendedProps.waitsOnPremise',
  mobilitySolution: 'extendedProps.mobilitySolution',
  pickUpAt: (data: any) => parseMoment(data.extendedProps?.pickUpAt, DateTimeFormat.LEGACY),
  pickingStatus: 'pickingStatus',
  checkedInAt: (data: any) => parseMoment(data.extendedProps?.checkedInAt),
  contacts: 'extendedProps.contacts',
  items: 'extendedProps.items',
  tags: (data: any) => parsePlannerEventTags(data.extendedProps?.tags),
  teamId: 'extendedProps.teamId',
  isMissingConfirmation: 'extendedProps.isMissingConfirmation',
  isCheckedOut: 'extendedProps.isCheckedOut',
  cleaningStatus: 'extendedProps.cleaningStatus',
  eventBy: 'extendedProps.eventBy',
  dossierOwner: 'extendedProps.dossierOwner',
  isMechanicPaused: 'extendedProps.isMechanicPaused',
  isInvoiced: 'extendedProps.isInvoiced',
  qualityControlStatus: 'extendedProps.qualityControlStatus',
  workPreparationStatus: 'extendedProps.workPreparationStatus',
  vehicle: (data: any) => parseVehicleSummary(data.extendedProps),
};

export function parsePlannerEvent(data: any): PlannerEvent | null {
  return parseEntity(data, SCHEMA, PlannerEvent);
}

export function parsePlannerEvents(data: any): Array<PlannerEvent> {
  return parseEntities(data, parsePlannerEvent);
}
